import type { MngItem } from 'analytics/types/EEC'
import type { FragmentItemsFieldsFragment } from '../services/fragments.generated'

export function getMngItems(
	items: FragmentItemsFieldsFragment[] | undefined
): MngItem[] {
	return (
		items?.map((itemMapped) => ({
			item_id: itemMapped.productId,
			item_category2: itemMapped.sizeId,
			item_variant: itemMapped.colorId,
			quantity: itemMapped.quantity,
		})) || []
	)
}
